import * as Yup from 'yup';

export const TokenSchema = Yup.object().shape({
  solicitado: Yup.object()
    .shape({
      sucursales: Yup.array()
        .of(
          Yup.object().shape({
            nombreRegion: Yup.string().required('nombreRegion es requerido'),
            nombreVia: Yup.string().required('nombreVia es requerido'),
            nombreComuna: Yup.string().required('nombreComuna es requerido'),
            nombreSucursal: Yup.string().required('nombreSucursal es requerido')
          })
        )
        .required('sucursales es requerido')
        .min(1, 'Debe contener al menos una sucursal'),
      nombreRol: Yup.string().required('nombreRol es requerido'),
      nombreEmpresa: Yup.string().required('nombreEmpresa es requerido')
    })
    .required('solicitado es requerido'),

  solicitante: Yup.object()
    .shape({
      nombreRegion: Yup.string().required('nombreRegion es requerido'),
      nombreVia: Yup.string().required('nombreVia es requerido'),
      nombreComuna: Yup.string().required('nombreComuna es requerido'),
      nombreRol: Yup.string().required('nombreRol es requerido'),
      nombreSucursal: Yup.string().required('nombreSucursal es requerido'),
      nombreUsuario: Yup.string().required('nombreUsuario es requerido'),
      nombreEmpresa: Yup.string().required('nombreEmpresa es requerido')
    })
    .required('solicitante es requerido'),

  codigoSolicitud: Yup.string()
    .matches(/^\d+$/, 'codigoSolicitud debe contener solo números')
    .required('codigoSolicitud es requerido'),

  correoElectronico: Yup.string()
    .email('Debe ser un correo electrónico válido')
    .required('correoElectronico es requerido')
});
